import { FC } from 'react';
import { navigate } from 'gatsby';
import { MeQuery } from 'lib/home/generated/types/api';
import {
  DefaultLayout,
  SelectPlanCard,
  SelectPlanCardContent,
  SelectPlanForm,
  SelectPlanFormValues
} from '../../../components';

const ChangePlanPage: FC = () => {
  const handleSubmit = (values: SelectPlanFormValues) => {
    navigate('/account/change-plan/confirm', { state: { planId: values.selectedPlan } });
  };

  return (
    <DefaultLayout backTo="/account">
      {({ me }: { me: MeQuery['me'] }) => (
        <SelectPlanCard>
          <SelectPlanCardContent className="md:w-[calc(100%-75px)]">
            <h3>Let's Find The Right Plan!</h3>

            <SelectPlanForm
              initialValues={{ selectedPlan: me.subscription.product_variant_id ?? '' }}
              handleSubmit={handleSubmit}
            />
          </SelectPlanCardContent>
        </SelectPlanCard>
      )}
    </DefaultLayout>
  );
};

export default ChangePlanPage;
